import CardNumber from 'components/CardNumber'
import Top from 'components/Top'

import {
  PiSpeedometerDuotone
} from 'react-icons/pi'

const Speed = () => {

  return <div className="scroll one hs in-air-2x gap-2x">
    <div className="vs gap-2x size-2x8">
      <h2 className="one">speed</h2>

      <span><PiSpeedometerDuotone /></span>
    </div>

    <div className="vs gap-2x">

      <CardNumber
        { ...{
          url: '/statistics/bySpeed/total',
          title: 'avg total',
          units: 'km/h',
          ceil: true
        } }
      />

      <CardNumber
        { ...{
          url: '/statistics/bySpeed/moving',
          title: 'avg moving',
          units: 'km/h',
          ceil: true
        } }
      />

    </div>

    <div className="vs gap-2x">

      <CardNumber
        { ...{
          url: '/statistics/bySpeed/max',
          title: 'max',
          units: 'km/h',
          ceil: true
        } }
      />

      <CardNumber
        { ...{
          url: '/statistics/bySpeed/min',
          title: 'min',
          units: 'km/h',
          ceil: true
        } }
      />

    </div>

    <Top
      { ...{
        url: '/statistics/bySpeed/top',
        units: 'km/h'
      } }
    />

  </div>

}

export default Speed
